import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AuthActions, SettingsActions } from '@portal/actions';
import MessageModal from '@portal/components/MessageModal/MessageModal';
import useReduxState from '@portal/hooks/useReduxState';
import { AccountStatus } from '@portal/models/enumerators';
import { translate } from '@portal/services/i18n';

import Icon from '~/assets/svg/onboarding/ic_reproved.svg?react';
import ThemedText from '@portal/components/ThemedText/ThemedText';

const OnboardingFinal = () => {
  const dispatch = useDispatch();

  const {
    settings: { settings },
    user: {
      me: {
        account: { status },
      },
    },
  } = useReduxState();

  const [regionAlertVisible, setRegionAlertVisible] = useState(false);

  useEffect(() => {
    if (!settings) {
      dispatch(SettingsActions.getSettings());
    }
  }, [dispatch, settings]);

  useEffect(() => {
    if (
      status === AccountStatus.PENDING_MANUAL_APPROVAL &&
      settings?.validateStates
    ) {
      setRegionAlertVisible(true);
    }
  }, [settings?.validateStates, status]);

  const handleLogout = () => {
    dispatch(AuthActions.logout());
  };

  return (
    <div className="onboarding-final">
      <ThemedText variant="h1">
        {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.FINAL.TITLE')}
      </ThemedText>
      <ThemedText variant="h2">
        {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.FINAL.SUBTITLE')}
      </ThemedText>
      <MessageModal
        open={regionAlertVisible}
        setVisible={setRegionAlertVisible}
        title={translate(
          'PAGES.AUTH.REGISTER.ONBOARD.PF.FINAL.REGION_ALERT.TITLE'
        )}
        onConfirm={handleLogout}
        buttonOkText={translate(
          'PAGES.AUTH.REGISTER.ONBOARD.PF.FINAL.REGION_ALERT.OK'
        )}
      >
        <div className="onboarding-final__reproved-modal">
          <ThemedText
            variant="body"
            className="onboarding-final__reproved-modal__text"
          >
            {translate(
              'PAGES.AUTH.REGISTER.ONBOARD.PF.FINAL.REGION_ALERT.TEXT'
            )}
          </ThemedText>
          <Icon className="onboarding-final__reproved-modal__image" />
        </div>
      </MessageModal>
    </div>
  );
};

export default OnboardingFinal;
